/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'ai-mate.agent-header-banner-label': 'Agentbanderoll',
  'ai-mate.agent-list.all-agents-section-title': 'Alla agenter',
  'ai-mate.agent-list.beta-lozenge-title': 'Beta',
  'ai-mate.agent-list.change-owner-success-flag-description': 'Du bytte ägare av {agentName} till {newOwnerName}',
  'ai-mate.agent-list.change-owner-success-flag-title': 'Ägaren har ändrats',
  'ai-mate.agent-list.delete-agent-confirm-body':
    'Är du säker på att du vill ta bort agenten? Åtgärden kan inte ångras.',
  'ai-mate.agent-list.delete-agent-confirm-title': 'Vill du radera "{agentName}"?',
  'ai-mate.agent-list.delete-agent-error': 'Det gick inte att ta bort agenten',
  'ai-mate.agent-list.delete-agent-error-flag-description':
    'Något gick fel när vi försökte ta bort agenten. Försök igen om en stund.',
  'ai-mate.agent-list.delete-agent-error-flag-title': 'Det gick inte att ta bort agenten',
  'ai-mate.agent-list.delete-agent-error.agent-in-use': 'Agenten används för närvarande. Försök igen senare.',
  'ai-mate.agent-list.delete-agent-error.agent-not-found': 'Hittade inte agenten.',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner':
    'Du kan bara ta bort agenter som du har skapat själv. Kontakta agentägaren.',
  'ai-mate.agent-list.delete-agent-success-flag-description': 'Du tog bort {agentName}',
  'ai-mate.agent-list.delete-agent-success-flag-title': 'Agenten har tagits bort',
  'ai-mate.agent-list.development-section-title': 'Utvecklingsagenter',
  'ai-mate.agent-list.recommended-agents-section-title': 'Rekommenderat',
  'ai-mate.agent-list.templates-description':
    'Använd mallarna för att skapa din egen utvecklingsagent. Välj rätt agentmall för ditt arbete, välj Använd mall och fyll sedan i mallens uppmaning med specifika uppgifter som lagringsplats, mapp, språk och bibliotek. Skapa skräddarsydda utvecklingsagenter för kodning av olika uppgifter, projekt eller lagringsplatser.',
  'ai-mate.agent-list.templates-lozenge-title': 'Mall',
  'ai-mate.agent-list.templates-title': 'Kodningsmallar',
  'ai-mate.agent-message.agent-not-found': 'Hittade inte agenten',
  'ai-mate.agent-message.convo-title': 'Chatt med {agentName} utlöst från inbäddad smart länk',
  'ai-mate.agent-message.copy-link': 'Kopiera agentlänk',
  'ai-mate.agent-message.prompt': 'Uppmaning',
  'ai-mate.agent-message.prompt-placeholder': 'Skriv ett meddelande till {agentName}',
  'ai-mate.agent-message.prompt-submit': 'Skicka in',
  'ai-mate.agent-message.view-profile': 'Visa profil',
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': 'Avbryt',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': 'Radera',
  'ai-mate.agent-picker.dropdown-item.non-default-agent-prefix': 'Agent · {description}',
  'ai-mate.agent-profile-info.chat-with-agent': 'Chatta med {agentName}',
  'ai-mate.agent-profile-info.hidden-icon': 'Dold',
  'ai-mate.agent-profile-info.hidden-tooltip': 'Agenten visas inte i sökresultaten',
  'ai-mate.agent-profile-info.star-agent-tooltip': 'Stjärnmärk agent',
  'ai-mate.agent-selector.default-agent-description': 'Få svar, generera nya idéer och snabba upp det dagliga arbetet.',
  'ai-mate.agent-selector.default-agent-name': 'Chatt',
  'ai-mate.profile-card-preview.actions-title': 'Åtgärder',
  'ai-mate.profile-card-preview.agent-default-title': 'Agent',
  'ai-mate.profile-card-preview.agent-description-label': 'Beskrivning',
  'ai-mate.profile-card-preview.agent-title-label': 'Rubrik',
  'ai-mate.profile-card-preview.conversation-starters-heading': 'Konversationsstartare',
  'ai-mate.profile-card-preview.empty-actions': 'Ingen',
  'ai-mate.profile-card-preview.empty-conversation-starters': 'Ingen',
  'ai-mate.profile-card-preview.empty-instructions': 'Ingen',
  'ai-mate.profile-card-preview.empty-knowledge-scope': 'Ingen har valts',
  'ai-mate.profile-card-preview.instructions-title': 'Instruktioner',
  'ai-mate.profile-card-preview.knowledge-title': 'Kunskap',
  'ai-mate.profile-card-preview.regenerate-label': 'Återskapa {fieldName}',
  'conversation-assistant-agent.create-agent.agent-name-copy': 'Kopia av {agentName}',
  'conversation-assistant-agent.create-agent.conversation-starters.drag-handle-label': 'Dra för att ändra ordning',
  'conversation-assistant-agent.create-agent.conversation-starters.form-error': 'Det gick inte att spara ändringarna',
  'conversation-assistant-agent.create-agent.conversation-starters.form-generic-error':
    'Ett okänt fel inträffade. Försök igen',
  'conversation-assistant-agent.create-agent.conversation-starters.form-name-exists-error':
    'Det finns redan en agent med det här namnet',
  'conversation-assistant-agent.create-agent.conversation-starters.remove-label': 'Ta bort',
  'conversation-assistant-agent.create-agent.generate-conversation-starters-button-text':
    'Generera konversationsstartare',
  'conversation-assistant-agent.create-agent.input-max-length-error-message':
    '{maxLength, plural, one {{fieldName} får inte överstiga {maxLength,number} tecken} other {{fieldName} får inte överstiga {maxLength,number} tecken}}',
  'conversation-assistant-agent.create-agent.next-step-button-label': 'Nästa',
  'conversation-assistant-agent.create-agent.restart-creation-button-label': 'Starta om',
  'conversation-assistant-agent.create-agent.skip-to-manual-setup-button-label': 'Gå till manuell inställning',
  'create-agent.owner-field.confirm-modal-cancel': 'Avbryt',
  'create-agent.owner-field.confirm-modal-confirm': 'Ja, fortsätt',
  'create-agent.owner-field.confirm-modal-content':
    'Du är på väg att ändra ägare av agenten till {name}. Om du gör det kan du inte längre redigera eller hantera agenten.',
  'create-agent.owner-field.confirm-modal-title': 'Du är på väg att förlora redigeringsåtkomst',
  'create-agent.owner-field.owner-description': 'Det här är personen som kan redigera eller hantera agenten.',
  'create-agent.owner-field.owner-label': 'Ägare',
  'rovo-chat.agent-card.deactivated-name': '{name} (inaktiverad)',
  'rovo-chat.browse-agents.agents-error-rate-limited-message': 'För många förfrågningar. Vänta en stund.',
  'rovo-chat.browse-agents.agents-error-try-again-button': 'Försök igen',
  'rovo-chat.browse-agents.all-agents-button': 'Alla',
  'rovo-chat.browse-agents.close-button': 'Stäng',
  'rovo-chat.browse-agents.create-agent-button': 'Skapa',
  'rovo-chat.browse-agents.create-an-agent-button': 'Skapa en agent',
  'rovo-chat.browse-agents.created-by-label': '<text>av</text> {creatorName}',
  'rovo-chat.browse-agents.development-button': 'Kodningsagenter',
  'rovo-chat.browse-agents.favorite-agents-button': 'Favoriter',
  'rovo-chat.browse-agents.favourited-agent-label': 'Favoritmarkerad agent',
  'rovo-chat.browse-agents.learn-more': 'Läs mer',
  'rovo-chat.browse-agents.modal-title': 'Bläddra bland agenter',
  'rovo-chat.browse-agents.my-agents-button': 'Mina agenter',
  'rovo-chat.browse-agents.no-created-agents':
    'Det verkar som att du inte har skapat några agenter än. Börja med att kopiera andra befintliga agenter eller skapa en från scratch.',
  'rovo-chat.browse-agents.no-created-agents-header': 'Inga agenter har skapats än',
  'rovo-chat.browse-agents.no-results': 'Inga resultat',
  'rovo-chat.browse-agents.no-starred-agents':
    'Om du har en favoritagent eller en som du använder ofta kan du komma åt den enkelt genom att stjärnmärka den.',
  'rovo-chat.browse-agents.no-starred-agents-header': 'Du har inte stjärnmärkt någon agent än',
  'rovo-chat.browse-agents.search-input.placeholder': 'Sök agenter',
  'rovo-chat.browse-agents.search-templates-input.placeholder': 'Sök bland mallar',
  'rovo-chat.browse-agents.see-all-agents-button': 'Se alla agenter',
  'rovo-chat.browse-agents.starred-agents-button': 'Stjärnmärkta',
  'rovo-chat.browse-agents.templates-button': 'Mallar',
  'rovo-chat.create-agent.actions-section-description':
    'Lägg till åtgärder för din agent så att den kan utföra uppgifter i Jira, Confluence och Jira Service Management. <link>Vad är agentåtgärder?</link>',
  'rovo-chat.create-agent.add-actions-button-label': 'Lägg till åtgärder',
  'rovo-chat.create-agent.all-content-label': 'Allt innehåll',
  'rovo-chat.create-agent.back-button': 'Gå tillbaka',
  'rovo-chat.create-agent.confirm-leave-modal.body': 'Du har inte skapat din agent än, vill du ta bort den?',
  'rovo-chat.create-agent.confirm-leave-modal.cancel-button': 'Avbryt',
  'rovo-chat.create-agent.confirm-leave-modal.confirm-button': 'Ja, ta bort agent',
  'rovo-chat.create-agent.confirm-leave-modal.title': 'Oavslutad agent',
  'rovo-chat.create-agent.confirm-restart-modal.body':
    'Är du säker på att du vill kassera alla ändringar som gjorts av agenten?',
  'rovo-chat.create-agent.confirm-restart-modal.confirm-button': 'Bekräfta',
  'rovo-chat.create-agent.confirm-restart-modal.title': 'Skapa på nytt',
  'rovo-chat.create-agent.confluence-checkbox-label': 'Confluence',
  'rovo-chat.create-agent.conversation-starters-field-description':
    'Personer kan använda dem för att starta en chatt med din agent. Vi kan generera dem åt dig om du inte kan komma på några.',
  'rovo-chat.create-agent.conversation-starters-field-label': 'Konversationsstartare',
  'rovo-chat.create-agent.create-agent-button': 'Skapa',
  'rovo-chat.create-agent.ctions-section-title': 'Åtgärder',
  'rovo-chat.create-agent.description-field-description':
    'Personer kan använda beskrivningen i agentens profil för att lära sig mer om den.',
  'rovo-chat.create-agent.description-field-label': 'Beskrivning',
  'rovo-chat.create-agent.description-field-placeholder':
    'Ange en kort beskrivning om din agent (till exempel kreativ författare av marknadsföringsbloggar)',
  'rovo-chat.create-agent.instructions-field-description':
    'Hur vill du att agenten ska bete sig? Vad kan den göra? <link>Mer om att skriva instruktioner för en agent</link>',
  'rovo-chat.create-agent.instructions-field-label': 'Instruktioner',
  'rovo-chat.create-agent.instructions-field-placeholder': 'Anpassa instruktionerna för den här agenten',
  'rovo-chat.create-agent.intro-description-part-1':
    'Skapa en agent med specialkunskap som kan svara på frågor, skriva och granska innehåll och utföra uppgifter som hjälper dig att ta arbetet framåt.',
  'rovo-chat.create-agent.intro-description-part-2':
    'Du kan <bold>gå till manuell inställning</bold> om du inte behöver hjälp.',
  'rovo-chat.create-agent.intro-description-part-3': 'Annars stannar du här så kan vi ändra inställningar tillsammans.',
  'rovo-chat.create-agent.intro-step-1-content':
    'Jag skapar instruktioner för agenten baserat på vad du skriver. Beskriv vad du planerar att använda agenten till.',
  'rovo-chat.create-agent.intro-step-1-title': 'Beskriv vad du vill att din agent ska göra',
  'rovo-chat.create-agent.intro-step-2-content':
    'Låt oss tillsammans bestämma ett namn och en personlighet för din agent. Är din agent empatisk, direkt eller rolig?',
  'rovo-chat.create-agent.intro-step-2-title': 'Skapa lite karaktär',
  'rovo-chat.create-agent.intro-step-3-content':
    'Klicka på <bold>Nästa</bold> för att granska din nya agent, lägga till åtgärder, kunskap och en profilbild. Välj <bold>Skapa</bold> när du är klar.',
  'rovo-chat.create-agent.intro-step-3-title': 'Granska och skapa din agent',
  'rovo-chat.create-agent.intro-title': '👋 Nu skapar vi din agent',
  'rovo-chat.create-agent.jira-checkbox-label': 'Jira',
  'rovo-chat.create-agent.jira-filter-placeholder': 'Alla projekt',
  'rovo-chat.create-agent.knowledge-field-description':
    'Specificera agentens kunskap genom att endast låta den använda de källor du anger',
  'rovo-chat.create-agent.knowledge-field-label': 'Kunskap',
  'rovo-chat.create-agent.knowledge-scope-checkbox-label': 'Använd endast dessa källor',
  'rovo-chat.create-agent.knowledge-select.suggestion-label': 'Föreslagna',
  'rovo-chat.create-agent.manage-actions-button-label': 'Hantera åtgärder',
  'rovo-chat.create-agent.name-field-description': 'Personer kan använda detta för att hitta agenten.',
  'rovo-chat.create-agent.name-field-label': 'Namn',
  'rovo-chat.create-agent.name-field-placeholder': 'Ange namnet på din agent',
  'rovo-chat.create-agent.natural-language-form-creator.generic-error': 'Ett oväntat fel inträffade. Försök igen.',
  'rovo-chat.create-agent.natural-language-form-creator.static-first-message':
    'Hej! Jag är här för att hjälpa dig att skapa en anpassad agent. Berätta vad du vill att agenten ska göra.',
  'rovo-chat.create-agent.nl-input-field.placeholder': 'Skriv ditt meddelande',
  'rovo-chat.create-agent.nl-input-field.send-button-label': 'Skicka',
  'rovo-chat.create-agent.page-title': 'Skapa en agent',
  'rovo-chat.create-agent.page-title-edit': 'Redigera agent',
  'rovo-chat.create-agent.search-for-pages-placeholder': 'Sök efter sidor',
  'rovo-chat.create-agent.search-for-spaces-placeholder': 'Sök efter utrymmen',
  'rovo-chat.create-agent.select-action-modal-all-tab-title': 'Alla',
  'rovo-chat.create-agent.select-action-modal-beta-tag': 'Beta',
  'rovo-chat.create-agent.select-action-modal-cancel-button': 'Avbryt',
  'rovo-chat.create-agent.select-action-modal-close-icon-tooltip': 'Stäng',
  'rovo-chat.create-agent.select-action-modal-confluence-tab-title': 'Confluence',
  'rovo-chat.create-agent.select-action-modal-jira-tab-title': 'Jira',
  'rovo-chat.create-agent.select-action-modal-many-actions-added-warning':
    '{count, plural, one {Att välja färre än {count,number} åtgärd leder till optimal prestanda} other {Att välja färre än {count,number} åtgärder leder till optimal prestanda}}',
  'rovo-chat.create-agent.select-action-modal-save-button': 'Spara',
  'rovo-chat.create-agent.select-action-modal-search-input-placeholder': 'Sök åtgärder',
  'rovo-chat.create-agent.select-action-modal-title': 'Lägg till åtgärder',
  'rovo-chat.create-agent.select-content-under-label': 'Välj innehåll under',
  'rovo-chat.create-agent.select-spaces-label': 'Välj utrymmen',
  'rovo-chat.create-agent.selected-actions-label': 'Valda åtgärder:',
  'rovo-chat.create-agent.unknown-owner': 'Okänd',
  'rovo-chat.create-agent.update-agent-button': 'Uppdatera',
  'rovo-chat.edit-agent.confirm-discard-modal.body':
    'Om du fortsätter förlorar du ändringar som inte sparats. Välj Avbryt för att fortsätta redigera agenten.',
  'rovo-chat.edit-agent.confirm-discard-modal.confirm-button': 'Fortsätt, ignorera ändringar',
  'rovo-chat.edit-agent.confirm-discard-modal.title': 'Kassera ändringar',
  'rovo-chat.view-agent.about-label': 'Om',
  'rovo-chat.view-agent.actions-label': 'Åtgärder',
  'rovo-chat.view-agent.beta-label': 'Beta',
  'rovo-chat.view-agent.beta-tag': 'Beta',
  'rovo-chat.view-agent.chat-to-agent-button': 'Chatta med en agent',
  'rovo-chat.view-agent.close-button': 'Stäng',
  'rovo-chat.view-agent.copy-instructions-label': 'Kopiera',
  'rovo-chat.view-agent.copy-instructions-tooltip': 'Kopiera instruktioner',
  'rovo-chat.view-agent.created-by-label': '<text>av</text> {agentName}',
  'rovo-chat.view-agent.favourites-metadata-label': 'Antal favoriter',
  'rovo-chat.view-agent.go-back-label': 'Gå tillbaka',
  'rovo-chat.view-agent.hidden-instructions-description':
    'Forge-agenter skapade med kod har sina instruktioner dolda i integritetssyfte.',
  'rovo-chat.view-agent.hidden-instructions-title': 'Instruktionerna är privata',
  'rovo-chat.view-agent.hidden-knowledge-description':
    'Forge-agenter skapade med kod använder inte vanliga kunskapskällor',
  'rovo-chat.view-agent.instructions-label': 'Instruktioner',
  'rovo-chat.view-agent.knowledge-label': 'Kunskap',
  'rovo-chat.view-agent.member-count': '{count, plural, one {{count,number} medlem} other {{count,number} medlemmar}}',
  'rovo-chat.view-agent.modal-title': 'Bläddra bland agenter',
  'rovo-chat.view-agent.no-actions': 'Inga åtgärder',
  'rovo-chat.view-agent.no-instruction-placeholder': 'Agenten har inga anpassade instruktioner',
  'rovo-chat.view-agent.no-knowledge-added': 'Inga anpassade kunskapskällor',
  'rovo-chat.view-agent.no-teams': 'Inte en del av något team',
  'rovo-chat.view-agent.open-chat-label': 'Öppna chatt',
  'rovo-chat.view-agent.reactions-metadata-label': 'Antal reaktioner',
  'rovo-chat.view-agent.rovo-agent-label': 'Rovo-agent',
  'rovo-chat.view-agent.teams-label': 'Team',
  'rovo-chat.view-agent.users-metadata-label': 'Antal användare',
};
